import React from 'react';
import { FormSelect } from '../crmFormElement/FormInput';
import { ReactComponent as DownArrow } from '../../../assets/images/svg/DownArrow.svg';

const HospitalCenterSelect: React.FC<any> = (props: any): any => {
  const { isLoading, baseForm, centerOptions, hospitalCenterChangeHandler,
    onPanelLeave, hideLabel = false, size, className, disabled } = props;
  return (
    <FormSelect
      detail={{
        isLoading,
        hideLabel,
        form: baseForm,
        key: 'hospitalCenter',
        size: size || 9,
        options: (centerOptions || []),
        showSearch: true,
        allowClear: true,
        suffixIcon: <DownArrow />,
        onChange: hospitalCenterChangeHandler,
        onPanelLeave,
        className,
        disabled,
      }}
    />
  );
};

export default HospitalCenterSelect;
